@if (redemptionEnabled) {
  <section class="cpa" dir="rtl" aria-labelledby="cpa-title">
    <div class="cpa__head">
      <span class="cpa__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="M20 12a2 2 0 0 1 2-2V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v3a2 2 0 0 1 0 4v3a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3a2 2 0 0 1-2-2zm-2-1.46a4 4 0 0 0 0 6.92V17H4v-.54a4 4 0 0 0 0-6.92V7h16v3.54zM11 15h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2z"/></svg>
      </span>
      <div class="cpa__copy">
        <h3 id="cpa-title" class="cpa__title">יש לך קוד הטבה?</h3>
        <p class="cpa__text">הזן את קוד ההטבה שקיבלת והפעל את מכסת הפרסום שלך</p>
      </div>
    </div>

    <form class="cpa__form" (submit)="submit($event)" novalidate>
      <label class="cpa__label" for="cpa-code">קוד הטבה (9 ספרות)</label>
      <div class="cpa__row">
        <input
          id="cpa-code"
          class="cpa__input"
          [class.cpa__input--invalid]="showValidation || !!error"
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          autocomplete="one-time-code"
          maxlength="9"
          dir="ltr"
          placeholder="000000000"
          [value]="code"
          [disabled]="sending"
          [attr.aria-invalid]="showValidation || !!error"
          [attr.aria-describedby]="showValidation ? 'cpa-hint' : (error ? 'cpa-error' : null)"
          (input)="onCodeInput($event)"
          (blur)="touched = touched || code.length > 0">
        <button type="submit" class="cpa__btn" [disabled]="sending" [attr.aria-busy]="sending">
          @if (sending) {
            <span class="cpa__spinner" aria-hidden="true"></span>
            מפעיל...
          } @else {
            הפעל קופון
          }
        </button>
      </div>
      @if (showValidation) {
        <p id="cpa-hint" class="cpa__hint">יש להזין קוד בן 9 ספרות (ספרות בלבד)</p>
      }
      @if (error) {
        <p id="cpa-error" class="cpa__error" role="alert">{{ error }}</p>
      }
    </form>

    <div class="cpa__live" role="status" aria-live="polite">
      @if (success) {
        <div class="cpa-success">
          <span class="cpa-success__check" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
          </span>
          <div class="cpa-success__body">
            <p class="cpa-success__msg">{{ success.message }}</p>
            @if (success.title) {
              <p class="cpa-success__title">{{ success.title }}</p>
            }
            @if (success.details.length) {
              <ul class="cpa-success__details">
                @for (line of success.details; track $index) {
                  <li>{{ line }}</li>
                }
              </ul>
            }
            <div class="cpa-success__actions">
              @if (showBenefitsLink) {
                <a class="cpa-success__link" routerLink="/personal/benefits">להטבות שלי</a>
              }
              <button type="button" class="cpa-success__close" (click)="dismissSuccess()">הפעלת קוד נוסף</button>
            </div>
          </div>
        </div>
      }
    </div>
  </section>
}
